(function(){
  function initCollapsibles(){
    document.querySelectorAll('.collapsible-content .collapsible-row').forEach(function(details){
      var summary = details.querySelector('summary');
      if(!summary) return;

      // If rendered initially open (from Liquid), mark as open
      if(details.hasAttribute('open')){
        details.classList.add('open');
      }

      summary.setAttribute('role','button');
      summary.setAttribute('aria-expanded', details.classList.contains('open'));

      summary.addEventListener('click', function(e){
        e.preventDefault();

        var isOpen = details.classList.contains('open');
        summary.setAttribute('aria-expanded', !isOpen);

        if(isOpen){
          // Close: remove open class, let CSS grid transition run, then remove open attr
          details.classList.remove('open');
          details.classList.add('closing');
          var grid = details.querySelector('.accordion__content-grid');
          if(grid){
            grid.addEventListener('transitionend', function handler(evt){
              if(evt.target !== grid) return;
              grid.removeEventListener('transitionend', handler);
              details.removeAttribute('open');
              details.classList.remove('closing');
            });
          } else {
            details.removeAttribute('open');
            details.classList.remove('closing');
          }
        } else {
          // Open: set open attr first so content is in DOM, then add class for transition
          details.setAttribute('open','');
          // Force a reflow so the grid transition triggers from 0fr
          details.offsetHeight;
          details.classList.add('open');
        }
      });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initCollapsibles);
  } else {
    initCollapsibles();
  }
})();